export const STATUS_BADGE_VARIANT = {
  TODO: 'todo',
  IN_PROGRESS: 'inProgress',
  DONE: 'done'
};

const JIRA_STATUS_CATEGORY_TO_VARIANT = {
  TODO: STATUS_BADGE_VARIANT.TODO,
  IN_PROGRESS: STATUS_BADGE_VARIANT.IN_PROGRESS,
  DONE: STATUS_BADGE_VARIANT.DONE
};

const JIRA_STATUS_CATEGORY_COLOR_TO_VARIANT = {
  'blue-gray': STATUS_BADGE_VARIANT.TODO,
  'medium-gray': STATUS_BADGE_VARIANT.TODO,
  yellow: STATUS_BADGE_VARIANT.IN_PROGRESS,
  green: STATUS_BADGE_VARIANT.DONE
};

export function getStatusBadgeVariantFromCategory(category) {
  return JIRA_STATUS_CATEGORY_TO_VARIANT[category] || STATUS_BADGE_VARIANT.TODO;
}

export function getStatusBadgeVariantFromCategoryColor(categoryColor) {
  const normalized = String(categoryColor || '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-');

  return JIRA_STATUS_CATEGORY_COLOR_TO_VARIANT[normalized] || STATUS_BADGE_VARIANT.TODO;
}

export function getStatusBadgeStyles(theme, variant = STATUS_BADGE_VARIANT.TODO) {
  const statusBadge = theme.palette.jiraIntegration.statusBadge;
  return statusBadge[variant] || statusBadge.todo;
}
